import { render, staticRenderFns } from "./AddFlourTypeModal.vue?vue&type=template&id=2c112bbf&"
import script from "./AddFlourTypeModal.vue?vue&type=script&lang=js&"
export * from "./AddFlourTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports